const BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api/social`
  : "http://localhost:5000/api/social";

async function get(path) {
  const res = await fetch(`${BASE}${path}`);
  if (!res.ok) throw new Error(`Social API ${path} → ${res.status}`);
  return res.json();
}

export const socialApi = {
  overview:   () => get("/overview"),
  compare:    () => get("/compare"),
  publication: (pub)  => get(`/${pub}`),
  trending:    (pub)  => get(`/${pub}/trending`),
  mostLiked:   (pub)  => get(`/${pub}/mostliked`),
  realtime:    (pub)  => get(`/${pub}/realtime`),
};
